import { api } from "../lib/api";

export const billingService = {
  // Public
  plans: (country) => api.get("/billing/plans", { params: country ? { country } : {} }).then((r) => r.data),
  packs: (country) => api.get("/billing/packs", { params: country ? { country } : {} }).then((r) => r.data),
  me: () => api.get("/billing/me").then((r) => r.data),
  countries: () => api.get("/billing/countries").then((r) => r.data),
  subscribe: (planId) => api.post("/billing/subscribe", { plan_id: planId }).then((r) => r.data),
  getPack: (packId) => api.get(`/billing/packs/${packId}`).then((r) => r.data),
  buyPack: (packId) => api.post("/billing/buy-pack", { pack_id: packId }).then((r) => r.data),
  buyPackOrder: (payload) => api.post("/billing/buy-pack/order", payload).then((r) => r.data),

  // FX (shared)
  fxRates: () => api.get("/fx/rates").then((r) => r.data),

  // Admin
  adminMetrics: () => api.get("/admin/billing/metrics").then((r) => r.data),
  adminCatalog: () => api.get("/admin/billing/catalog").then((r) => r.data),
  adminAiSuggestions: () => api.post("/admin/billing/ai-suggestions").then((r) => r.data),
  adminRevenueForecast: () => api.get("/admin/billing/revenue-forecast").then((r) => r.data),
  adminForecastConfig: () => api.get("/admin/billing/forecast-config").then((r) => r.data),
  adminForecastConfigUpdate: (cfg) => api.patch("/admin/billing/forecast-config", cfg).then((r) => r.data),
  adminMpTestInfo: () => api.get("/admin/billing/mp-test-info").then((r) => r.data),
  adminMpCreateTestBuyer: (country = "CO") => api.post("/admin/billing/mp-create-test-buyer", null, { params: { country } }).then((r) => r.data),
  adminMpSetTestBuyer: (country, email) => api.post("/admin/billing/mp-set-test-buyer", { country, email }).then((r) => r.data),

  adminListPlans: (params = {}) => api.get("/admin/billing/plans", { params }).then((r) => r.data),
  adminCreatePlan: (payload) => api.post("/admin/billing/plans", payload).then((r) => r.data),
  adminUpdatePlan: (id, patch) => api.patch(`/admin/billing/plans/${id}`, patch).then((r) => r.data),
  adminDeletePlan: (id) => api.delete(`/admin/billing/plans/${id}`).then((r) => r.data),
  adminResyncPlan: (id) => api.post(`/admin/billing/plans/${id}/resync-mp`).then((r) => r.data),
  adminListPacks: () => api.get("/admin/billing/packs").then((r) => r.data),
  adminCreatePack: (payload) => api.post("/admin/billing/packs", payload).then((r) => r.data),
  adminUpdatePack: (id, patch) => api.patch(`/admin/billing/packs/${id}`, patch).then((r) => r.data),
  adminDeletePack: (id) => api.delete(`/admin/billing/packs/${id}`).then((r) => r.data),
  adminListPayments: (params = {}) => api.get("/admin/billing/payments", { params }).then((r) => r.data),
  adminListSubscriptions: (params = {}) => api.get("/admin/billing/subscriptions", { params }).then((r) => r.data),
  adminPlanActivate: (id) => api.post(`/admin/billing/plans/${id}/activate`).then((r) => r.data),
  adminPlanDeactivate: (id) => api.post(`/admin/billing/plans/${id}/deactivate`).then((r) => r.data),
  adminPlanClone: (id) => api.post(`/admin/billing/plans/${id}/clone`).then((r) => r.data),
  adminPlanNewVersion: (id) => api.post(`/admin/billing/plans/${id}/new-version`).then((r) => r.data),
  adminPlanCancel: (id, body) => api.post(`/admin/billing/plans/${id}/cancel`, body).then((r) => r.data),

  adminListPlansByKind: (kind, status) => api.get("/admin/billing/plans", { params: { ...(kind ? { kind } : {}), ...(status ? { status } : {}) } }).then((r) => r.data),
  adminProrationConfig: () => api.get("/admin/billing/proration-config").then((r) => r.data),
  adminProrationConfigUpdate: (cfg) => api.patch("/admin/billing/proration-config", cfg).then((r) => r.data),

  adminPackActivate: (id) => api.post(`/admin/billing/packs/${id}/activate`).then((r) => r.data),
  adminListPackVersions: (id) => api.get(`/admin/billing/packs/${id}/versions`).then((r) => r.data),
  adminPackDeactivate: (id) => api.post(`/admin/billing/packs/${id}/deactivate`).then((r) => r.data),
  adminPackClone: (id) => api.post(`/admin/billing/packs/${id}/clone`).then((r) => r.data),
  adminPackNewVersion: (id) => api.post(`/admin/billing/packs/${id}/new-version`).then((r) => r.data),
  adminPackCancel: (id, body) => api.post(`/admin/billing/packs/${id}/cancel`, body).then((r) => r.data),

  // composition (user-facing)
  compositionStart: (body) => api.post("/billing/composition/start", body).then((r) => r.data),
  compositionUpdate: (body) => api.post("/billing/composition/update", body).then((r) => r.data),
  compositionCancel: () => api.post("/billing/composition/cancel").then((r) => r.data),
  compositionCancelPending: () => api.post("/billing/composition/cancel-pending").then((r) => r.data),
  // iter-168: lifecycle reversibility + recovery
  compositionCancelPendingCancellation: () =>
    api.post("/billing/composition/cancel-pending-cancellation").then((r) => r.data),
  compositionCancelPendingDowngrade: () =>
    api.post("/billing/composition/cancel-pending-downgrade").then((r) => r.data),
  compositionReactivate: () =>
    api.post("/billing/composition/reactivate").then((r) => r.data),
  // iter-168d: Win-back configurable
  winbackEligibility: () => api.get("/billing/winback/eligibility").then((r) => r.data),
  winbackClaim: () => api.post("/billing/winback/claim").then((r) => r.data),
  adminWinbackConfig: () => api.get("/admin/billing/winback-config").then((r) => r.data),
  adminWinbackConfigUpdate: (patch) =>
    api.patch("/admin/billing/winback-config", patch).then((r) => r.data),
  compositionMe: () => api.get("/billing/composition/me").then((r) => r.data),
  myHistory: () => api.get("/billing/me/history").then((r) => r.data),
  myUserPacks: () => api.get("/billing/me/packs").then((r) => r.data),
  consumeUserPack: (id, units = 1) => api.post(`/billing/me/packs/${id}/consume`, null, { params: { units } }).then((r) => r.data),
  // iter-170l — user-side cancel of a pending manual consumption
  // request. Refunds the debited units and clears the pending lock.
  cancelPackRequest: (id) => api.post(`/billing/me/packs/${id}/cancel-request`).then((r) => r.data),
  secondariesForPrimary: (lineage, country) => api.get(`/billing/secondaries-for-primary/${lineage}`, { params: country ? { country } : {} }).then((r) => r.data),
};
